class UserRenamingConfiguratorManualDirective {
    constructor($http, translateService) {
        this.restrict = 'E';
        this.template = `<div ng-hide="editing">
                            <span ng-if="threadUserName === ''" ng-click="edit()"><a>{{ 'configuratorManual.addConfiguratorManualName' | t }}...</a></span>
                            <span ng-if="threadUserName !== ''">
                                <a ng-click="edit()"><i class="fa fa-pencil"></i></a>
                                <a href="/user/configurator/manual/thread/{{ threadId }}">{{ threadUserName }}</a>
                            </span>
                        </div>
                        <div ng-show="editing === true">
                            <input type="text" class="form-control" ng-model="localThreadUserName" on-enter="save()" on-escape="cancel()" style="display: inline-block; width: calc(100% - 40px);" />
                            <a ng-click="save()"><i class="fa fa-save"></i></a>
                            <a ng-click="cancel()"><i class="fa fa-times-circle"></i></a>
                        </div>`;
        this.scope = {
            changeFn: '&change',
            threadUserName: '@value'
        };
        this.$http = $http;
        this.translate = translateService;
    }

    link(scope, element, attrs) {
        let _this = this;

        scope.threadUserName = attrs.threadUserName;
        scope.threadId = attrs.threadId;

        scope.editing = false;

        scope.edit = function() {
            scope.editing = true;
            scope.localThreadUserName = scope.threadUserName;
        };

        scope.cancel = function() {
            scope.editing = false;
            scope.localThreadUserName = scope.threadUserName;
        };

        scope.save = function() {
            scope.editing = false;
            scope.threadUserName = scope.localThreadUserName;

            _this.$http.post('/user/configurator/manual/ajax/saveThreadName', {thread_id: scope.threadId, thread_user_name: scope.threadUserName}, {
                headers: {'Content-Type': 'application/json'}
            }).then(
                () => {},
                () => {
                    alert(_this.translate.t('configuratorManual.errors.unexpected'));
                }
            );

            scope.changeFn({ $text: scope.localThreadUserName });
        };
    }

    static directiveFactory($http, translateService) {
        'ngInject';
        return new UserRenamingConfiguratorManualDirective($http, translateService);
    }
}

export default UserRenamingConfiguratorManualDirective;